<template>
    <section class="page-section" v-loading="pageLoading">

                <el-form size="small" label-width="0px" class="content-form">

                    <!-- 账户信息 -->
                    <div class="form-module no-margin-top">
                        <div class="module-header">基本信息</div>
                        <div class="module-body clearfix">
                            <div class="info">
                                <div class="flex-h">
                                    <div>
                                        <span class="text">ID：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.id }}</span>
                                    </div>
                                </div>
                                <div class="flex-h">
                                    <div>
                                        <span class="text">公司代理名称：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.name }}</span>
                                    </div>
                                </div>
                                <div class="flex-h">
                                    <div>
                                        <span class="text">服务代理等级：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.serviceLevel }}</span>
                                    </div>
                                    <div style="margin-left: 40px">
                                        <span class="text">商品代理等级：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.productLevel }}</span>
                                    </div>
                                </div>
                                <div class="flex-h">
                                    <div>
                                        <span class="text">公司联系人：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.contact }}</span>
                                    </div>
                                    <div style="margin-left: 40px">
                                        <span class="text">联系人手机号：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ detail.mobile }}</span>
                                    </div>
                                </div>
                                <div class="flex-h">
                                    <div>
                                        <span class="text">添加时间：</span>
                                    </div>
                                    <div>
                                        <span class="text">{{ COMMON.formatDate('2', '-', detail.createDate) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- tabs -->
                    <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange" style="margin-top: 20px">
                        <el-tab-pane label="分销收益" name="1"></el-tab-pane>
                        <el-tab-pane label="员工排行" name="2"></el-tab-pane>
                        <el-tab-pane :label="'员工(' + detail.employeeNum + ')'" name="3"></el-tab-pane>
                        <el-tab-pane label="子代理排行" name="4"></el-tab-pane>
                        <el-tab-pane :label="'子代理(' + detail.childAgentNum + ')'" name="5"></el-tab-pane>
                        <el-tab-pane label="提现记录" name="6"></el-tab-pane>
                    </el-tabs>

                    <!-- tab list -->
                    <div class="form-module">
                        <div class="module-body">
                            <!-- table -->
                            <div class="table-region" v-loading="tableLoading">
                                <template v-if="tabName == '1'">
                                    <!-- 分销收益 -->
                                    <div class="statistics">
                                        <span class="item">可提现：￥{{ statistics.validBalance || 0 }}</span>
                                        <span class="item">冻结中：￥{{ statistics.frozenBalance || 0 }}</span>
                                        <span class="item">已提现：￥{{ (statistics.withdrawBalance || 0) }}</span>
                                    </div>
                                    <!-- sub tabs -->
                                    <el-tabs v-model="subTabName" type="card" @tab-click="handleTabsChange" style="margin-top: 10px">
                                        <el-tab-pane label="服务订单" name="2"></el-tab-pane>
                                        <el-tab-pane label="商品订单" name="1"></el-tab-pane>
                                    </el-tabs>
                                    <template v-if="subTabName == '2'">
                                        <!-- 服务订单统计 -->
                                        <div class="statistics default" style="margin-top: 10px">
                                            <span class="item">服务订单总金额：￥{{ statistics.serviceOrderAmount || 0 }}</span>
                                            <span class="item">服务订单总笔数：{{ statistics.serviceOrderNum || 0 }}</span>
                                            <span class="item">服务订单总收益：￥{{ (statistics.serviceOrderIncome || 0) }}</span>
                                        </div>
                                    </template>
                                    <template v-if="subTabName == '1'">
                                        <!-- 商品订单统计 -->
                                        <div class="statistics default" style="margin-top: 10px">
                                            <span class="item">商品订单总金额：￥{{ statistics.productOrderAmount || 0 }}</span>
                                            <span class="item">商品订单总笔数：{{ statistics.productOrderNum || 0 }}</span>
                                            <span class="item">商品订单总收益：￥{{ (statistics.productOrderIncome || 0) }}</span>
                                        </div>
                                    </template>
                                    <!-- 订单列表 -->
                                    <el-table size="small" :data="tableData" style="margin-top: 20px">
                                        <el-table-column label="发放收益">
                                            <template slot-scope="scope">
                                                <p>+{{ scope.row.income }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="发放时间">
                                            <template slot-scope="scope">
                                                <p>{{ COMMON.formatDate('2', '-', scope.row.incomeTime) }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :label="subTabName == '2' ? '项目' : '商品'">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.item }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="订单号">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.orderNumber }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="订单金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.orderAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="订单成交时间">
                                            <template slot-scope="scope">
                                                <p>{{ COMMON.formatDate('2', '-', scope.row.orderCompletionTime) }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="下级顾客">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.subCustomer }}<template v-if="scope.row.subCustomerMobile">({{ scope.row.subCustomerMobile }})</template></p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="subTabName == '2'" label="订单凭证">
                                            <template slot-scope="scope">
                                                <template v-if="scope.row.orderVoucherImages && scope.row.orderVoucherImages.length > 0">
                                                    <el-image
                                                        style="width: 48px; height: 48px; cursor: pointer;"
                                                        :src="scope.row.orderVoucherImages[0]"
                                                        :preview-src-list="scope.row.orderVoucherImages"
                                                        fit="cover">
                                                    </el-image>
                                                </template>
                                                <span v-else style="color: #999;">-</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="tabName == '2'">
                                    <!-- 员工排行 -->
                                    <el-table size="small" :data="tableData">
                                        <el-table-column label="员工姓名">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.name }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="工作手机号">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.mobile }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="销售总金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.saleAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="销售总笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.saleNum }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务订单金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.serviceAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务订单笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.serviceNum }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品订单金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品订单笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productNum }}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="tabName == '3'">
                                    <!-- 员工 -->
                                    <el-table size="small" :data="tableData">
                                        <el-table-column label="ID">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.id }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="员工姓名">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.name }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="工作手机号">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.mobile }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="添加时间" sort-by="">
                                            <template slot-scope="scope">
                                                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="tabName == '4'">
                                    <!-- 子代理排行 -->
                                    <el-table size="small" :data="tableData">
                                        <el-table-column label="ID">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.userId }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="代理">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.userName }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="销售总金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.saleAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="销售总笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.saleNum }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务代理等级">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.distributorLevel }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务订单金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.serviceAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务订单笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.serviceNum }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品代理等级">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productLevel }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品订单金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productAmount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品订单笔数">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productNum }}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="tabName == '5'">
                                    <!-- 子代理 -->
                                    <el-table size="small" :data="tableData">
                                        <el-table-column label="ID">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.id }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="代理">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.name }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="服务代理等级">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.serviceLevelName }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="商品代理等级">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.productLevelName }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="添加时间" sort-by="">
                                            <template slot-scope="scope">
                                                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                                <template v-if="tabName == '6'">
                                    <!-- 提现记录 -->
                                    <el-table size="small" :data="tableData">
                                        <el-table-column label="提现申请时间">
                                            <template slot-scope="scope">
                                                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="提现金额">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.amount }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="提现账户">
                                            <template slot-scope="scope">
                                                <p>
                                                    <span>开户行：{{ scope.row.bank }}</span><br>
                                                    <span>卡号：{{ scope.row.cardId }}</span>
                                                </p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="提现完成时间">
                                            <template slot-scope="scope">
                                                <p v-if="scope.row.status == 1">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="状态">
                                            <template slot-scope="scope">
                                                <p v-if="scope.row.status == 0">处理中</p>
                                                <p v-if="scope.row.status == 1">提现成功</p>
                                                <p v-if="scope.row.status == 2">提现失败</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>

                                <div class="table-footer" v-if="page.total > 0">
                                    <div class="selection-operate"></div>

                                    <div class="pagination-wrap">
                                        <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :page-sizes="[20, 50, 100]"
                                            :current-page="page.current"
                                            :page-size="page.size"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="page.total">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>

            </section>
</template>

<script>
    import {
        COMMON,
        agentCompanyDetail,
        agentIncome,
        agentServiceOrderStatics,
        agentProductOrderStatics,
        agentOrderList,
        distributorSalesRank,
        agentCompanyDetailEmployeeList,
        distributorChildAgentRank,
        agentChildAgents,
        agentCompanyDetailWithdrawalList, agentCompanyDetailWithdrawal } from '@/common/api';

    export default {
        data() {
            return {
                COMMON,

                id: this.$route.query.id || '',

                pageLoading: true, // 页面loading
                detail: {}, // 详情

                tabName: '1',
                subTabName: '2',

                tableData: [],
                tableLoading: false,
                page: { // 分页参数
                    current: 1,
                    size: 20,
                    total: 0 
                },

                statistics: {
                    validBalance: 0,
                    frozenBalance: 0,
                    withdrawBalance: 0,
                    serviceOrderAmount: 0,
                    serviceOrderNum: 0,
                    serviceOrderIncome: 0,
                    productOrderAmount: 0,
                    productOrderNum: 0,
                    productOrderIncome: 0
                },

                operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
            }
        },
        methods: {
            /**
             * [getDetail description] 获取详情
             * @return {[type]} [description]
             */
            getDetail: function() {
                let params = {
                    id: this.id
                }

                agentCompanyDetail(params).then(res =>{
                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.detail = data;
                        this.pageLoading = false;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleTabsChange description] 切换选项卡
             * @param  {[type]} tab   [description] 取name值用tab.name
             * @param  {[type]} event [description]
             * @return {[type]}       [description]
             */
            handleTabsChange: function(tab, event) {
                this.page.current = 1;
                this.tableData = [];
                this.getList();
            },
            /**
             * [getList description] 获取 tab 列表数据
             * @return {[type]} [description]
             */
            getList: function() {
                if(this.tabName == '1') {
                    // 分销收益
                    if(this.subTabName == '2') {
                        // 服务订单
                        this.getOrderList(2)
                    } else if(this.subTabName == '1'){
                        // 商品订单
                        this.getOrderList(1)
                    }
                } else if(this.tabName == '2') {
                    // 员工排行
                    this.getAgentRankList()
                } else if (this.tabName == '3') {
                    // 员工
                    this.getAgentList()
                } else if(this.tabName == '4') {
                    // 子代理排行
                    this.getChildAgentRankList()
                } else if (this.tabName == '5') {
                    // 子代理
                    this.getChildAgentList()
                } else if (this.tabName == '6') {
                    // 提现记录
                    this.getWithdrawalList()
                }
            },
            /**
             * [getAgentIncome description] 分销收益统计
             * @return {[type]} [description]
             */
            getAgentIncome: function() {
                let params = {
                    companyId: this.id
                }

                agentIncome(params).then(res =>{
                    let { code, data, msg } = res;

                    if(code == 0) {
                        const { validBalance, frozenBalance, withdrawBalance } = data
                        Object.assign(this.statistics, {
                            validBalance,
                            frozenBalance,
                            withdrawBalance
                        })
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getServiceOrderStatics description] 服务订单统计
             * @return {[type]} [description]
             */
            getServiceOrderStatics: function() {
                let params = {
                    companyId: this.id
                }

                agentServiceOrderStatics(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        const { serviceOrderAmount, serviceOrderNum, serviceOrderIncome } = data
                        Object.assign(this.statistics, {
                            serviceOrderAmount,
                            serviceOrderNum,
                            serviceOrderIncome
                        })
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getProductOrderStatics description] 商品订单统计
             * @return {[type]} [description]
             */
            getProductOrderStatics: function() {
                let params = {
                    companyId: this.id
                }

                agentProductOrderStatics(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        const { productOrderAmount, productOrderNum, productOrderIncome } = data
                        Object.assign(this.statistics, {
                            productOrderAmount,
                            productOrderNum,
                            productOrderIncome
                        })
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getOrderList description] 服务、商品订单列表
             * @return {[type]} [description]
             */
            getOrderList: function(type) {
                this.tableLoading = true;

                let params = {
                    companyId: this.id,
                    pageNo: this.page.current,
                    type,
                    pageSize: this.page.size
                }

                agentOrderList(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getAgentRankList description] 员工排行
             * @return {[type]} [description]
             */
            getAgentRankList: function() {
                this.tableLoading = true;

                let params = {
                    companyId: this.id,
                    pageNo: this.page.current,
                    pageSize: this.page.size
                }

                distributorSalesRank(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getAgentList description] 员工
             * @return {[type]} [description]
             */
            getAgentList: function() {
                this.tableLoading = true;

                let params = {
                    id: this.id,
                    current: this.page.current,
                    size: this.page.size
                }

                agentCompanyDetailEmployeeList(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getChildAgentRankList description] 子代理排行
             * @return {[type]} [description]
             */
            getChildAgentRankList: function() {
                this.tableLoading = true;

                let params = {
                    companyId: this.id,
                    pageNo: this.page.current,
                    pageSize: this.page.size
                }

                distributorChildAgentRank(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getChildAgentList description] 子代理
             * @return {[type]} [description]
             */
            getChildAgentList: function() {
                this.tableLoading = true;

                let params = {
                    id: this.id,
                    current: this.page.current,
                    size: this.page.size
                }

                agentChildAgents(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getWithdrawalList description] 提现记录
             * @return {[type]} [description]
             */
            getWithdrawalList: function() {
                this.tableLoading = true;

                let params = {
                    companyId: this.id,
                    current: this.page.current,
                    size: this.page.size
                }

                agentCompanyDetailWithdrawalList(params).then(res =>{
                    let { code, data, msg} = res;

                    if(code == 0) {
                        this.tableData = data.records || [];
                        this.tableLoading = false;
                        this.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },

            /**
             * [handleSizeChange description] 分页每页条数变化
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleSizeChange(val) {
                this.page.current = 1;
                this.page.size = val;

                this.getList();
            },
            /**
             * [handleCurrentChange description] 选择分页第几页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCurrentChange(val) {
                this.page.current = val;

                this.getList();
            }
        },
        mounted: function() {
            this.getDetail();
            this.getList();
            this.getAgentIncome()
            this.getServiceOrderStatics()
            this.getProductOrderStatics()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/base/_mixin-font';
    @import "../../../common/styles/base/mixin-common";

    .statistics{
        margin-top: -10px;
        padding: 10px;
        background: #EFFAFF;
        border-radius: 4px;
        font-size: 0;

        &.default{
            border: 1px solid #D9D9D9;
            background: transparent;
        }

        .item{
            font-size: 12px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 600;

            & + .item{
                margin-left: 80px;
            }
        }
    }

    .no-margin-top {
        margin-top: 0;
    }

    .mr-10 {
        margin-right: 10px;
    }

    .mr-20 {
        margin-right: 20px;
    }

    .pt-pb-10 {
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }

    .item-tab-body {
        margin: 10px 0;
        font-size: $smallFS;

        div {
            position: relative;
            display: inline-block;
            padding: 10px 30px;
            cursor: pointer;

            &.current {
                color: $themeColor;

                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 3px;
                    background: $themeColor;
                    z-index: 1;
                }
            }
        }
    }

    .order-list-item {

        &.only-bottom-border {
            border: none;
            border-bottom: 1px solid $separateDefaultColor !important;            
        }

        .customTableDropDownListBackgroundColor {
            margin-left: 0 !important;
            margin-right: 0 !important;
            padding: 10px 5px;
            background-color: $customTableDropDownListBackgroundColor;
        }

        .overdue {
            opacity: .5;
            filter: alpha(opacity = 50);
        }

        .item-body-body {
            margin: 0 10px;

            &.no-margin {
                margin: 0;
            }
            
            .item-body-body-header {
                background-color: $colorTitleBg;
            }

            .item-body-body-body {
                padding: 10px 0;
            }
        }
    }

    .module-body {
        .text {
            font-size: $smallFS;
            color: $textColor;
            line-height: 27px;
        }

        .avatar {
            position: relative;
            float: left;
            width: 150px;
            height: 150px;
            margin-left: 10px;
            /*background: $colorImgBg;*/

            img{
                max-width: 100%;
                max-height: 100%;
                @include position(absolute, 1, 50%, none, none, 50%);
                @include translate(-50%, -50%, 0);
            }
        }
        
        .info {
            float: left;
            margin-left: 10px;
        }

        .personal-info-box {
            margin-bottom: 40px;

            .personal-info {
                float: left;
                margin-left: 10px;
            }

            .personal-avatar-info {
                float: left;
                margin-left: 40px;
                
                .personal-avatar {
                    position: relative;
                    margin-top: 5px;
                    width: 200px;
                    height: 130px;
                    background: $colorImgBg;

                    img{
                        max-width: 100%;
                        max-height: 100%;
                        @include position(absolute, 1, 50%, none, none, 50%);
                        @include translate(-50%, -50%, 0);
                    }
                }
            }

            .personal-first-avatar-info {
                float: left;
                margin-left: 40px;

                .personal-first-avatar {
                    position: relative;
                    margin-top: 5px;
                    width: 200px;
                    height: 130px;
                    background: $colorImgBg;

                    img{
                        max-width: 100%;
                        max-height: 100%;
                        @include position(absolute, 1, 50%, none, none, 50%);
                        @include translate(-50%, -50%, 0);
                    }
                }
            }
        }
    }

    .dialog-photo-past {
        position: relative;
        margin: 0 auto;
        padding: 10px 0;

        p {
            margin-bottom: 20px;
            text-align: center;
        }

        .pic-list {
            position: relative;           
            margin: 0 auto;
            width: 420px;
            height: 130px;

            .pic-item {
                position: relative;
                width: 110px;
                height: 130px;
                margin: 0 15px;
                background: $colorImgBg;

                img{
                    @include position(absolute, 3, 50%, none, none, 50%);
                    max-width: 100%;
                    max-height: 100%;
                    @include translate(-50%, -50%, 0);
                }
            }
        }

        .left-icon,
        .right-icon {
            position: absolute;
            z-index: 5;
            top: 50%;
            margin-top: -20px;
            font-size: 34px;
            color: $swiperArrowColor;
            cursor: pointer;

            &:hover {
                color: $darkButtonBackgroundHoverColor;
            }

            &[disabled="disabled"] {
                opacity: .3;
                cursor: not-allowed;
            }
        }

        .left-icon {
            left: 0;
        }

        .right-icon {
            right: 0;
        }
    }
</style>
